import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from '../../services/Auth';

class InvoiceMonthlies extends Api {
  constructor() {
    super('finance/invoice_monthlies/');
  }

  approve(id, data) {
    return this.buildQuery(
      'post',
      {
        data,
      },
      `${id}/approve`,
    );
  }
  confirm_replace(id) {
    return this.buildQuery('post', {}, `${id}/confirm_replace`);
  }

  getPDF(url) {
    return axios({
      url,
      method: 'get',
      data: {},
      params: {},
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  }

  getExcelSingle = (id) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/finance/invoice_monthlies/${id}.xlsx`,
      method: 'get',
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default InvoiceMonthlies;
